import { httpClient } from '@connectors/HttpClient'

import type { FeatureFlagRule } from '../types'

export const FeatureFlagRuleService = {
    list: async (): Promise<FeatureFlagRule[]> => {
        const response = await httpClient.axios.get('/admin/feature-flag-rules')
        return response.data
    },
    create: async (params: Partial<FeatureFlagRule>): Promise<any> => {
        const { featureFlagId, model, field, comparator, value } = params
        const response = await httpClient.axios.post(`/admin/feature-flag-rules`, {
            data: { featureFlagId, model, field, comparator, value }
        })
        return response.data
    },
    delete: async (id: string): Promise<any> => {
        const response = await httpClient.axios.delete(`/admin/feature-flag-rules/${id}`)
        return response.data
    }
}
